/**
 * Reducer for any errors that might need to appear
 */

import { ActionTypes as types } from '../constants'

function getInitialState() {
  return {
    show: false,
    type: '',
    message: '',
    duration: '',
  }
}

export default function globalToast(state = getInitialState(), action) {
  switch (action.type) {
    case types.GLOBAL_TOAST.CLOSE_GLOBAL_TOAST:
      return {
        ...state,
        show: false,
      }
    case types.GLOBAL_TOAST.SHOW_GLOBAL_TOAST:
      return {
        ...state,
        show: true,
        type: action.data?.type,
        message: action.data?.message,
        duration: action.data?.duration,
      }

    default:
      return state
  }
}
